import { render } from "./PhysicalBranch.vue?vue&type=template&id=2418d2b0&scoped=true"
import script from "./PhysicalBranch.vue?vue&type=script&lang=js"
export * from "./PhysicalBranch.vue?vue&type=script&lang=js"

import "./PhysicalBranch.vue?vue&type=style&index=0&id=2418d2b0&scoped=true&lang=css"

import exportComponent from "/var/www/html/online-ordering/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2418d2b0"]])

export default __exports__